/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_On_Preview_HintInputs */

const en_wc_on_preview_hint = /** @type {(inputs: Wc_On_Preview_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best on a desktop or laptop. Click inside the editor to use keyboard shortcuts.`)
};

/**
* | output |
* | --- |
* | "Best on a desktop or laptop. Click inside the editor to use keyboard shortcuts." |
*
* @param {Wc_On_Preview_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_on_preview_hint = /** @type {((inputs?: Wc_On_Preview_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_On_Preview_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_on_preview_hint(inputs)
});
export { wc_on_preview_hint as "wc.on.preview_hint" }